import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NbMenuBag, NbMediaBreakpointsService, NbMenuService, NbThemeService } from '@nebular/theme';
import { filter } from 'rxjs/operators/filter';
import { UserData } from '../../../@core/data/users';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomAuthServiceService } from '../../../auth/custom-auth-service.service';
import { UtilsService } from '../../../manageb/utils.service';
import { environment } from '../../../environment/environment.base';
import { NavStateService } from '../../nav-shell/nav-state.service';
// import { WorkflowService } from '../../../services/workflow.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  tag = 'header-context-menu';
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user = {
    name: '',
    picture: '',
    firstLast: '',
  };

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';
  user1 = JSON.parse(localStorage.getItem('currentUser'))
  stagingClientName = environment.env === 'staging' ? 'Staging Not Live' : '';


  userMenu;
  readonly navEnabled = this.nav.enabled;
  readonly railHidden$ = this.nav.railHidden$;
  readonly headerNotice$ = this.nav.headerNotice$;

  // variables for the notification service
  subscription: Subscription;
  pendingNotifications: boolean;
  clientName = '';

  constructor(
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private breakpointService: NbMediaBreakpointsService,
    private route: Router,
    private loginService: CustomAuthServiceService,
    protected utils: UtilsService,
    private nav: NavStateService,
  ) {

  }

  logoClicked() {
    this.loginService.goToDefaultScreen();
  }

  setUserDetails() {
    this.user.picture = '';
    this.user.firstLast = this.user.name.split(' ')?.[0]?.[0] + this.user.name.split(' ')?.[1]?.[0];
  }

  ngOnInit() {
    this.applyUser();
    

    
    this.currentTheme = this.themeService.currentTheme;


    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.nick);
    this.setUserDetails();

    this.menuService.onItemClick()
      .pipe(filter((bag: NbMenuBag) => bag.tag === this.tag), takeUntil(this.destroy$))
      .subscribe((event) => {
        this.onItemSelection(event.item.title);
      })

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.route.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => document.body.classList.remove('sidebar-mobile-open'));

    // get te user pending notification upon login
    this.waitForClientName();
  }

  private applyUser() {
    if (this.loginService.currentUserValue()) {
      this.user.name = this.loginService.currentUserValue()['fullName'];
      const role = this.loginService.currentUserValue()['role'];
      this.userMenu = this.navEnabled
        // The redesign moves navigation into the panel, so the avatar menu is account-only.
        ? (role > 800 ? [{ title: 'Profile' }, { title: 'Log out', pathMatch: '' }, { title: 'Use As SA' }]
                      : [{ title: 'Profile' }, { title: 'Log out', pathMatch: '' }])
        : (role > 800 ? [{ title: 'Profile' }, { title: 'Log out', pathMatch: '' }, { title: 'Use As SA' }]
                      : [{ title: 'Profile' }, { title: 'Log out', pathMatch: '' }, { title: 'Bed Board' }, { title: 'New Push To PCC' }, { title: 'Admin' }]);
    } else {
      console.log('There is no user get name from local storage', localStorage.getItem('fullName'))
      if (localStorage.getItem('fullName')) {
        this.user.name = localStorage.getItem('fullName') || '';
      }
    }
  }

  refreshHeader() {
    this.applyUser();

    this.waitForClientName();
  }
  onItemSelection(title: string) {
    if (title === 'Log out') {
      // this.workflow.resetProcessData()
      this.loginService.goToLogin(undefined, false) // voluntary logout — don't restore last page
    } else if (title === 'Profile') {
      this.route.navigate(['/client/accounts'])
    } else if (title === 'Use As SA') {
      // user1 is a construction-time snapshot; read fresh so an impersonation made since then is dropped.
      const user = this.loginService.currentUserValue() ?? JSON.parse(localStorage.getItem('currentUser'))
      delete user['contactAs']
      localStorage.setItem('currentUser', JSON.stringify(user))
      // Keep the in-memory user in step, or role-driven surfaces stay on the impersonated role.
      this.loginService.updateUser(user)
      this.loginService.goToAfterLogin(user)
    } else if (title == 'Bed Board') {
      this.route.navigate(['/manageb/bed-boards'])
    } else if (title == 'New Push To PCC') {
      this.route.navigate(['/manageb/push'], {state: {isPccNew: true}})
    } else if(title == 'Admin') {
      this.route.navigate(['/manageb/admin/dashboard'])
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  dismissNotice(): void {
    this.nav.dismissHeaderNotice();
  }

  toggleRail(): void {
    this.nav.toggleRailHidden();
  }

  toggleSidebar(): boolean {
    if (this.navEnabled) {
      this.nav.setDrawerOpen(true);
      return false;
    }
    document.body.classList.toggle('sidebar-mobile-open');
    return false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!document.body.classList.contains('sidebar-mobile-open')) return;
    const target = event.target as HTMLElement;
    if (!target.closest('nb-sidebar') && !target.closest('.mobile-hamburger')) {
      document.body.classList.remove('sidebar-mobile-open');
    }
  }

  goToPendingNAlerts() {
    this.route.navigateByUrl('manage/pending-n-alerts');
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  firstLast() {
    return 'FS';
  }

  private waitForClientName() {
    this.clientName = this.utils.clientSettings.clientName;
    console.log('clientName', this.clientName);
    setTimeout(() => {
      if (this.clientName) {
        return;
      }
      this.waitForClientName();
    }, 100);
  }
}
